import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TyreSetCard } from "@/components/TyreSetCard";
import { TyreSetDialog } from "@/components/TyreSetDialog";
import { useT } from "@/lib/i18n";

export const EventTyreSets = ({ eventId, sets, onChange }) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  return (
    <section data-testid="event-tyre-sets" className="mt-14">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold uppercase text-2xl sm:text-3xl tracking-tight">
          {t("tyre_sets")} <span data-testid="tyre-sets-count" className="font-mono text-lg text-slate-500">[{sets.length}]</span>
        </h2>
        <Button data-testid="new-tyre-set-btn" variant="outline" onClick={() => setOpen(true)}
          className="rounded-sm bg-transparent border-[#FFB800]/50 text-[#FFB800] hover:bg-[#FFB800]/10 hover:text-[#FFB800] font-heading uppercase tracking-wide text-base h-10 px-4">
          <Plus className="w-4 h-4 mr-1" /> {t("new_tyre_set")}
        </Button>
      </div>
      {sets.length === 0 ? (
        <div data-testid="tyre-sets-empty" className="border border-dashed border-[#282D3D] rounded-sm p-10 text-center text-slate-500 font-mono text-sm">{t("no_tyre_sets_event")}</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {sets.map((s, i) => <TyreSetCard key={s.id} set={s} index={i} />)}
        </div>
      )}
      <TyreSetDialog open={open} onOpenChange={setOpen} eventId={eventId} onSaved={onChange} />
    </section>
  );
};
